Event.on('Listing.fetchedData', () => {
    bLazy.revalidate();

    setTimeout(function(){
        bLazy.revalidate();
    }, 300);
});

Cart.customCallbacks.addedItem = function (form, response) {
    var $submitButton = $(form).find('[type="submit"]');

    if (!response.status) {
        $submitButton.addClass('has-error');
    }

    $submitButton
        .addClass('is-loaded')
        .removeClass('is-loading')
        .prop('disabled', false);

    if (checkResolution('ie')) {
        setTimeout(function() {
            $submitButton.removeClass('is-loaded');
        }, 1000);
    } else {
        $submitButton.one('animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd', function() {
            $submitButton.removeClass('is-loaded');
        });
    }
}

Event.on('Cart.product.before_add', function(form) {
    $(form).find('[type="submit"]')
        .removeClass('has-error')
        .addClass('is-loading')
        .prop('disabled', true);
});

Eshop.alert = function (msg, options) {
    var settings = $.extend({
        allow_dismiss: true,
        type: 'success',
        animate: {
            enter: 'fadeInRight',
            exit: 'fadeOutRight'
        },
        placement: {
            from: checkResolution('cxs;xs') ? 'bottom' : 'top'
        },
        gap: 2,
        delay: 4500,
        mouse_over: 'pause',
        offset: {
            y: checkResolution('cxs;xs') ? 15 : 136
        },
        z_index: 3003,
        template:
            '<div data-notify="container" class="notify custom {0}" role="alert">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
                    '<i class="ico ico-close-thick" aria-hidden="true"></i>' +
                '</button>' +
                '<span class="message" data-notify="message">{2}</span>' +
            '</div>'
    }, options);

    $.notify(msg, settings);
}

$(function() {
    setTimeout(function() {
        jQuery.validator.addMethod("email", function (value, element) {
            return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || value == '';
        });

        jQuery.validator.addMethod("phone", function(value, element) {
            return /^[0-9+][0-9 ]{8,17}$/.test(value.replace(/\s/g, '')) || value == '';
        });

        jQuery.validator.addMethod("exactLengthWithoutSpaces", function (value, element, param) {
            return value.replace(/\s/g, '').length == param;
        }, jQuery.validator.messages.exactlength);

        jQuery.validator.addMethod("postCode", function(value, element) {
            return /^[0-9+][0-9 ]{8,17}$/.test(value) || value == '';
        });

        if ($('.js-form-reg').length) {
            $('.js-form-reg').validate().settings.rules.post_code = {
                digitsWithSpaces: true,
                exactLengthWithoutSpaces: 5
            };
        }
    }, 0);

    Listing.customCallbacks.afterFetch = function () {
        if ($('.js-pager-current-count').length) {
            $('.js-pager-current-count').html($('.listing.products').first().find('.listing__item').length);
        }
    }

    $('.js-custom-form-modal-login').validate({
        rules: {
            login: {
                email: true
            }
        },
        submitHandler: function(form) {
            $(form).find('button[type="submit"]').addClass('is-loading');
            $('.js-login-error').slideUp(100);

            Form.ajaxPost(form, function(data) {
                if (!data.status) {
                    $('.js-login-error')
                        .text(data.message)
                        .slideDown(150);
                } else {
                    $('.js-login-hide').slideUp(150);
                    $('.js-login-success').slideDown(150);

                    location.reload();
                }

                $(form).find('button[type="submit"]').removeClass('is-loading');
            }, 'json');
        }
    });

    $(document).on('click', '.pager__load .c-btn', function () {
        $(this).addClass('is-loading');
    });
});